module.exports = {
  base: {
    api: {
      getAllModelLines: '/dealercenter/rest/modelLine/allModelLines',
      getModelTrims: '/dealercenter/rest/modelLine/modelLineTrims',
      getTrimOffers: '/dealercenter/rest/offers',
      getTrimIncentives: '/dealercenter/rest/offers/incentive',
      getDMA: '/dealercenter/rest/dma/by',
      getPaymentOptions: '/dealercenter/rest/offers/allinone',
      getBestOffers: '/dealercenter/rest/offers/bestOffers',
      getDealersByZip: '/dealercenter/rest/listDealersByZipCode',
    },
    headCssLinks: [
      '/styleguide/css/nna-infiniti-styleguide-helios.min.css',
      '/webfonts/fonts/infiniti-thin.css',
      '/webfonts/fonts/infiniti-metapro.css',
      '/webfonts/fonts/icon-Infiniti-Global.css',
      '/webfonts/fonts/Infiniti-BrandL1-Light.css',
      '/webfonts/fonts/Infiniti-BrandL1-Bold.css',
      '/webfonts/fonts/Infiniti-BrandL1-Regular.css'
    ],
    heliosHeadCssLinks: [
      '<link rel="stylesheet" media="print, screen" href="https://www.infinitiusa.com/content/dam/Infiniti/US/assets/includes/menu/css/small.min.css">',
      '<link rel="stylesheet" media="print, screen and (min-width: 36.3125em)" href="https://www.infinitiusa.com/content/dam/Infiniti/US/assets/includes/menu/css/medium.min.css">',
      '<link rel="stylesheet" media="print, screen and (min-width: 60em)" href="https://www.infinitiusa.com/content/dam/Infiniti/US/assets/includes/menu/css/large.min.css">',
      '<link rel="stylesheet" media="print" href="https://www.infinitiusa.com/content/dam/Infiniti/US/assets/includes/menu/css/print.min.css">'
    ],
    cookies: {
      zipCode: 'ZipCode',
      visitorId: 'visitorID'
    }
  },
  languages: {
    en: {
      appBuild: 'dist/infiniti/pe-infiniti/lease-finance-payment-calculator',
      landingPage: '/pe-infiniti/lease-finance-payment-calculator',
      headJsImports: [
        '/libs/api/external/helios/dtm.js'
      ],
      heliosHeadJsImports: [
        'https://www.infinitiusa.com/content/dam/Nissan/us/assets/includes/menu/js/vendor/jquery/jquery-2.0.3.min.js',
        'https://www.infinitiusa.com/content/dam/Infiniti/US/assets/includes/menu/js/header-include.js',
        'https://www.infinitiusa.com/content/dam/Infiniti/US/assets/includes/menu/js/footer-include.js',
      ],
      heliosLogin: 'https://owners.infinitiusa.com/nowners/',
      heliosLiveChatURL: 'http://nna.force.com/livechat/LiveAgent_NewInfinitiIFS?routingGroup=InfinitiGlobalNav',
      heliosPageTitle: 'Infiniti USA',
      heliosLogoLink: 'https://www.infinitiusa.com/',
      headerLoaded: false,
      footerLoaded: false,
      bodyInnerAfterJSImports: [
        '/styleguide/js/global-navigation-full.min.js'
      ],
    }
  },
  slots: {
    dev: {
      protocol: 'https:',
      rootPath: 'localhost:3000',
      brandPath: 'http://infinitiusa-validation-1.criticalmass.com/'
    },
    validation: {
      protocol: 'https:',
      rootPath: '',
      brandPath: ''
    },
    uat: {
      protocol: 'https:',
      rootPath: '',
      brandPath: ''
    },
    production: {
      protocol: 'https:',
      rootPath: '',
      brandPath: ''
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./config/brand/helios/infiniti.js
 ** module id = 255
 ** module chunks = 0
 **/